import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import axios from 'axios';
import App from './App';
import './index.css';

axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let sessionExpiredHandled = false;
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || '';
    const isLoginCall = url.endsWith('/login');
    if (status === 401 && !isLoginCall) {
      if (!sessionExpiredHandled) {
        sessionExpiredHandled = true;
        localStorage.removeItem('jwtToken');
        localStorage.removeItem('sessionActive');
        localStorage.removeItem('loggedInUser');
        alert('❌ Session expired — please log in to the admin panel again.');
        window.location.href = '/';
      }
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);